// src/utils/lastLocation.js
const KEY = 'lingrow:lastLocation';

export function saveLastLocation(path) {
  try { localStorage.setItem(KEY, path); } catch (_) {}
}

export function getLastLocation() {
  try { return localStorage.getItem(KEY) || null; } catch (_) { return null; }
}

export function clearLastLocation() {
  try { localStorage.removeItem(KEY); } catch (_) {}
}
